/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { LinkButton } from '@veeam/components';

import type { LinkButtonProps, SelectLinkProps } from '@veeam/components';

import { useFullPage } from '../../hooks/use-full-page';

import type { UseFullPageProps } from '../../hooks/use-full-page';

export interface FullPageButtonProps extends LinkButtonProps, Pick<SelectLinkProps, 'renderContent'>, Omit<UseFullPageProps, 'render'> {
    renderFullPageWindow: UseFullPageProps['render'];
    customButton?: React.ReactElement;
}

export const FullPageButton: React.FC<FullPageButtonProps> = (props) => {
    const {
        children,
        headerHeight,
        renderFullPageWindow,
        customButton: CustomButton,
        isExtMode,
        zIndexForFullPageWindow,
        disabled,
        error,
        renderContent,
        onClick,
        initialActiveState,
        onClose,
        overlayProps,
        ...restProps
    } = props;
    const ButtonLink: any = CustomButton ? CustomButton : LinkButton;
    const [fullPageWizard, fullPageWizardActions] = useFullPage({
        initialActiveState,
        render: renderFullPageWindow,
        headerHeight,
        isExtMode,
        zIndexForFullPageWindow,
        onClose,
        overlayProps,
    });

    return (
        <>
            <ButtonLink
                {...restProps}
                disabled={disabled}
                error={error}
                onClick={(event: React.MouseEvent) => {
                    event.preventDefault();
                    fullPageWizardActions.activate();
                    onClick?.(event);
                }}
            >
                {renderContent?.({ error, disabled }) || children}
            </ButtonLink>

            {fullPageWizard}
        </>
    );
};
